<template>
    <div id='mailForm'>
        <el-form :model="form" label-position="top" :rules="formRule" ref="formRef">
            <el-row type="flex">
                <el-col :span="colSpan">
                    <el-form-item label="聯繫人姓名" prop="name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item label="公司（選填)" prop="company">
                        <el-input v-model="form.company"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan" style="display: flex;align-items:flex-end ;justify-content: space-between;">
                    <el-form-item label="聯絡電話" prop="phoneArea">
                        <el-select v-model="form.phoneArea" placeholder="号码归属地">
                            <el-option
                            v-for="item in QCcellCoreList"
                            :key="item.id"
                            :label="item.area"
                            :value="item.area">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    <el-form-item prop="phone" class="phoneInput">
                        <el-input v-model="form.phone" placeholder="聯絡電話"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-model="form.email"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item>
                        <el-radio-group v-model="form.addressType">
                            <el-radio label="0">居住地區</el-radio>
                            <el-radio label="1">商業地區</el-radio>
                        </el-radio-group>
                        </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item label="地址行1  只接受英文输入" prop="addressOne">
                        <el-input v-model="form.addressOne"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item label="地址行2" prop="addressTwo">
                        <el-input v-model="form.addressTwo"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item label="地址行3" prop="addressThree">
                        <el-input v-model="form.addressThree"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item label="座數 或 樓層 或 室" prop="address">
                        <el-input v-model="form.address"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item label="邮编" prop="code">
                        <el-input placeholder="例如: 11451" v-model="form.code"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan" v-if="typeof countryId == 'undefined'">
                    <el-form-item label="国家或地区" prop="regionId">
                        <el-select v-model="form.regionId" @change="handlerCountryChange" placeholder="国家或地区">
                            <el-option
                            v-for="item in countryList"
                            :key="item.id"
                            :label="item[_i18n.locale == 'en' ? 'nameEC' : 'name']"
                            :value="item.id"
                            >
                          </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan" v-if="form.regionId == 2">
                    <el-form-item label="區域" prop="city">
                        <el-select v-model="form.city" placeholder="區域">
                            <el-option
                            v-for="item in cityList"
                            :key="item.cityEn"
                            :label="item[_i18n.locale == 'en' ? 'cityEn' : 'cityCn']"
                            :value="item.cityEn">
                          </el-option>
                        </el-select>
                      </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item label="城市" prop="city" v-if="form.regionId != 2">
                        <el-input v-model="form.city"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item label="州份" prop="regionProvinceId" v-if="ancientList.length > 0 && form.regionId != 2">
                        <el-select v-model="form.regionProvinceId" placeholder="州份">
                            <el-option
                            v-for="item in ancientList"
                            :key="item.id"
                            :label="item[_i18n.locale == 'en' ? 'provinceEn' : 'provinceCn']"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
export default {
    name:'MailForm',
    props:["typeId","callback","isTrigger","initTrigger","contextForm","isContact", "countryId"],
    data(){

        // 验证邮箱正则
            let checkEamil = (rule,value,callback)=>{
            // 自定义正则
            // const regEmail = /^[A-Za-z0-9]+@+[A-Za-z0-9*]+[\.]+[A-Za-z0-9]*$/
            const regEmail = /^[A-Za-z0-9/.]+@+[A-Za-z0-9*]+[/.A-Za-z0-9]*$/
            if(!regEmail.test(value)) return callback(new Error('請輸入正確的電郵格式!'))
            return callback()
        }

        // 验证电话正则
        let checkMobile = (rule,value,callback)=>{
            // 自定义正则
            const regMobile= /^[0-9]{8,11}$/
            // const  regMobile = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
            if(!regMobile.test(value)) return callback(new Error('請輸入正確的電話格式!'))
            return callback()
        }

        return {
            // 当前每行占的宽度
            colSpan:11,
            // 寄件人表单
            form:{

                // 街道
                address: "",

                // 所属城市
                city: "",

                // 邮政编码
                code: "",

                // 姓名
                name: "",

                // 公司
                company:'',

                // 电话
                phone: "",

                // 电话区号
                phoneArea: "",

                // 邮箱
                email:"",

                // 商业地址还是居住地址
                addressType:"",

                // 地址行
                addressOne:"",

                addressTwo:"",

                addressThree:"",

                // 1为寄件人信息2为收件人信息
                typeId: 1,

                // 所属国家ID
                regionId:"",

                // 州份ID
                regionProvinceId:"",

                // 城市
                city:"",

                // 取件日期
                pickupDate:"",

                // 最晚取件日期
                endTime:"",

                // 最早取件日期
                startTime:"",
            },
              // 表单规则
           formRule:{
                name:[
                    {required:true,message:"* 請填寫全名。",trigger:'blur'}
                ],
                company:[
                    {required:true,message:"* 請填寫公司名稱",trigger:'blur'}
                ],
                phone:[
                    {required:true,message:"* 請填寫聯絡電話。",trigger:'blur'},
                    {validator:checkMobile,trigger:'blur'}
                ],
                QCcellCore:[
                    {required:true,message:"* 請填寫電話區號。",trigger:'blur'}
                ],
                email:[
                    {required:true,message:"* 請填寫聯絡电邮。",trigger:'blur'},
                    {validator:checkEamil,trigger:'blur'}    
                ],
                addressOne:[
                    {required:true,message:" 請輸入地址一",trigger:'blur'}
                ],
                addressTwo:[
                    {required:true,message:" 請輸入地址二",trigger:'blur'}
                ],
                addressThree:[
                    {required:true,message:"* 請填寫地址。",trigger:'blur'}
                ],
                phoneArea:[
                    {required:true,message:" 请输入手机区号",trigger:'blur'}
                ],
                code:[
                    {required:true,message:"請填寫郵編",trigger:'blur'}
                ],
                address:[
                    {required:true,message:"請填寫街道",trigger:'blur'}
                ],
                city:[
                    {required:true,message:"請輸入都市",trigger:'blur'}
                ],
                regionProvinceId:[
                    {required:true,message:"請選擇州份",trigger:'blur'}
                ],
                regionId:[
                    {required:true,message:"請選擇國家或地區",trigger:'blur'}
                ],
            },
            // 号码归属地列表
            QCcellCoreList:[],
            // 州份列表
            ancientList:[],
            // 国家地区列表
            countryList:[],
            // 城市列表
            cityList:[]
        }
    },
    methods: {
        // 获取国家和地区
        async getRegion(){
            let res = await this.$http.get("app/v2/getRegion")
            console.log(res,"国家地区列表")
            if(!res.data.code) return this.$message.error("獲取國家地區失敗")
            this.countryList = res.data.data
        },
        // 监听用户选择国家
        async handlerCountryChange(value){
            console.log(value)
            let res = await this.$http.get("app/v2/getRegionProvince?regionId="+value)
            console.log(res,"周份")
            if(!res.data.code)  this.$message.error("獲取區域資訊失敗")
            else{
                this.ancientList = res.data.data
            }
            
            // this.ancientList = res.data.data[0].cityList
            let cityRes = await this.$http.get("app/v2/getRegionCity?regionId="+value)
            console.log(cityRes,"城市")
            if(!cityRes.data.code)  this.$message.error("獲取城市資訊失敗")
            else{
                this.cityList = cityRes.data.data
            }
        },
        // 获取号码归属地列表
        async getQCcellCore(){
            let res = await this.$http.get('app/data/getCurrency')
            console.log(res.data.data,"归属地列表")
            this.QCcellCoreList = res.data.data
        },
        // 初始化表单
        initForm(){
            // 如果有传表单的类型就赋值
            if(typeof this.typeId != "undefined"){
                this.form.typeId = this.typeId
            }
            if(typeof this.contextForm != 'undefined'){
                this.form = this.contextForm
                this.getRegion()
                this.handlerCountryChange(this.contextForm.regionId)
            }
        }
    },
    watch:{
        // 监视父组件是否要让我触发回调
        isTrigger(value){
            if(value){
                this.$refs.formRef.validate(async valid=>{
                    if(this.isContact){
                        this.initTrigger()
                    }
                    if(!valid) return  this.initTrigger()
                    // 如果成功就发表单传给父组件
                   this.callback(this.form)
                })
            }
        },
        contextForm(value){
            console.log(value,"改变的值")
            if(this.contextForm != 'undefined'){
                this.form = value
                this.getRegion()
                if(typeof this.countryId != 'undefined'){
                    // 有传国家id
                    this.form.regionId = this.countryId
                    this.handlerCountryChange(this.countryId)
                }else{
                    this.handlerCountryChange(value.regionId)
                }
            }
        }
    },
    // 生命周期创建完成
    mounted() {
        // 获取号码归属里列表
        this.getQCcellCore()
        // 获取国家地区
        this.getRegion()
        // 初始化表单
        this.initForm()

        if(typeof this.countryId != 'undefined'){
            // 有传国家id
            this.form.regionId = this.countryId
            this.handlerCountryChange(this.countryId)
        }
    }
}
</script>

<style lang="less">

</style>